module.exports = __webpack_public_path__ + "static/media/8.c7569cb4.jpg";